import * as React from 'react';
import { StyleSheet } from 'aphrodite/no-important';
import { generateLinkStyleFromTheme, TextLinkComponent } from '../../../partials/link/TextLink';
import { useTheme } from '../../../../theming/useTheme';
import { MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';
import { P, semanticCSS } from '../../../../typography/semanticTags';
import { BaseUnit } from '../../../../theming/baseUnitDefinition';

const componentConfigurationKey = 'bottomFooterBar';

interface BottomFooterBarThemeProps {
  backgroundColor: string;
  baseUnit: BaseUnit;
  textColor: string;
}

export interface BottomFooterBarDataProps {
  year: number;
  rightsReservedText: string;
  poweredByLink: {
    text: string;
    href: string;
  };
}

const getBottomFooterBarStyle = ({ backgroundColor, baseUnit, textColor }: BottomFooterBarThemeProps) => StyleSheet.create({
  style: {
    backgroundColor,
    color: textColor,
    padding: `${baseUnit * 0.5}px`,
    [MEDIA_BREAKPOINTS.medium]: {
      textAlign: 'center',
    },
    [MEDIA_BREAKPOINTS.small]: {
      textAlign: 'center',
    },
  },
});

export const BottomFooterBar: React.FunctionComponent<BottomFooterBarDataProps> = props => {
  const themeProps = useTheme<BottomFooterBarThemeProps>(componentConfigurationKey);
  const bottomFooterBarStyle = getBottomFooterBarStyle(themeProps);
  const { textColor } = themeProps;
  const { year, rightsReservedText, poweredByLink } = props;
  const linkStyle = generateLinkStyleFromTheme({ idleColor: textColor, activeStateColor: textColor, hoverStateColor: textColor });

  return (
    <P styles={semanticCSS(bottomFooterBarStyle.style)}>
      <TextLinkComponent href={poweredByLink.href} linkStyle={linkStyle} rel="noopener" target="_blank">
        {poweredByLink.text}
      </TextLinkComponent>
      {` © ${year} ${rightsReservedText}`}
    </P>
  );
};
